// extracted by mini-css-extract-plugin
export var brand = "_32-9";
export var button = "_32-0";
export var chevron = "_32-v";
export var chevronButton = "_32-w";
export var content = "_32-n";
export var danger = "_32-g";
export var dangerOutlined = "_32-h";
export var dark = "_32-l";
export var darkTheme = "_32-c";
export var extraSmall = "_32-4";
export var fullWidth = "_32-8";
export var ghost = "_32-d";
export var gray = "_32-t";
export var icon = "_32-p";
export var iconButton = "_32-s";
export var iconButtonBorder = "_32-x";
export var iconButtonBorderDark = "_32-y";
export var iconButtonBorderLight = "_32-z";
export var iconLeft = "_32-q";
export var iconRight = "_32-r";
export var large = "_32-1";
export var light = "_32-m";
export var medium = "_32-2";
export var micro = "_32-5";
export var nano = "_32-7";
export var outlined = "_32-k";
export var pending = "_32-a";
export var primary = "_32-i";
export var shadow = "_32-o";
export var small = "_32-3";
export var solidLight = "_32-e";
export var solidLightBrand = "_32-f";
export var spinner = "_32-u";
export var transparent = "_32-j";
export var warning = "_32-b";
export var wideNano = "_32-6";